import { useParamsSearch } from '@anytag/shared-hooks';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { AffiliateReportChart } from '@anytag/shared-molecules';
import { getValuableVariables } from '@anytag/shared-utils';
import {
  AffiliateReportShowBy,
  MarketplaceCampaignDetailType,
  useMarketplaceAffiliateReportSummaryQuery
} from '@anytag/graphql';
import {
  MarketplaceAffiliateReportTable,
  MarketplaceAffiliateReportFilter,
  MarketplaceAffiliateReportSummary,
  MarketplaceAffiliateReportSearchSchemaType
} from '@anytag/shared-organisms';
import { useMarketplaceDetailsContext } from '../marketplace-details-context';

export const MarketplaceAffiliateReport = () => {
  const {
    marketplace: { id, currency, campaignType }
  } = useMarketplaceDetailsContext();
  const { filter, setFilter } = useParamsSearch<MarketplaceAffiliateReportSearchSchemaType>();

  const { data, loading } = useMarketplaceAffiliateReportSummaryQuery({
    skip: !filter,
    variables: getValuableVariables({
      campaignId: id,
      endDate: filter.endDate,
      startDate: filter.startDate,
      showBy: filter.mode as AffiliateReportShowBy
    })
  });

  const summaryData = data?.marketplaceAffiliateReportSummary || undefined;
  const isReferralCampaign = campaignType === MarketplaceCampaignDetailType.REFERRAL_CODE;

  return (
    <>
      <MarketplaceAffiliateReportFilter filter={filter} setFilter={setFilter} campaignId={id} />

      <RenderDataWithFallback loading={loading}>
        <MarketplaceAffiliateReportSummary
          data={summaryData}
          currency={currency}
          isReferralCampaign={isReferralCampaign}
        />

        <AffiliateReportChart data={summaryData?.chartData} />

        <MarketplaceAffiliateReportTable
          filter={filter}
          campaignId={id}
          currency={currency}
          setFilter={setFilter}
          summaryData={summaryData}
          isReferralCampaign={isReferralCampaign}
        />
      </RenderDataWithFallback>
    </>
  );
};
